import React, { Fragment} from 'react'
import {  Outlet } from 'react-router-dom'
import { ReactComponent as Baglogo } from '../../assets/Baglogo.svg'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../store/user/user-selector'
import CartIcon from '../../components/cart-icon/cart-icon'
import CartDropdown from '../../components/cart-dropdown/cart-dropdown'
import { NavigationContainer, LogoContainer, NavLink, NavLinks, Logo } from './Navigation_style'
import { signOutUser } from '../../utils/firebase/firebase'
import { selectIsCartOpen } from '../../store/cart/cart selector'




const Navigation = () => {
  const currentUser = useSelector(selectCurrentUser);
  const isCartOpen = useSelector(selectIsCartOpen);
  const signOutHandler = async () => {
    await signOutUser();
  }
  return (
    <Fragment>
      <NavigationContainer>
        <LogoContainer to="/">
          <Logo>
            <Baglogo/>
          </Logo>
        </LogoContainer>
        <NavLinks>
          <NavLink to='/shop'>Shop</NavLink>
          {
            currentUser ? (<NavLink as='span' onClick={signOutHandler}>Sign out</NavLink>) : (
              <NavLink to='/auth'>Sign in</NavLink>)
          }
          <NavLink to='/checkout'>Checkout</NavLink>
          <CartIcon />
        </NavLinks>
        {isCartOpen && <CartDropdown />}
      </NavigationContainer>
      <Outlet />
    </Fragment>
  )
}
export default Navigation
